/*
 * @Author: Ashley.Liu
 * @Date: 2022-11-01 14:30:09
 * @LastEditTime: 2022-11-01 18:20:07
 * @Description: desc
 */
import 'codemirror/addon/lint/lint.css'
require('script-loader!jsonlint')
import 'codemirror/mode/javascript/javascript'
import 'codemirror/addon/lint/lint'
import 'codemirror/addon/lint/json-lint'
